import { render, staticRenderFns } from "./PlacesFeedWidget.vue?vue&type=template&id=6f287eb8&"
import script from "./PlacesFeedWidget.vue?vue&type=script&lang=js&"
export * from "./PlacesFeedWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f287eb8')) {
      api.createRecord('6f287eb8', component.options)
    } else {
      api.reload('6f287eb8', component.options)
    }
    module.hot.accept("./PlacesFeedWidget.vue?vue&type=template&id=6f287eb8&", function () {
      api.rerender('6f287eb8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dynamic-list-items/widgets/feeds/PlacesFeedWidget.vue"
export default component.exports